import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';


const override = {
  baseUrl: 'https://pioneer-ci2-service.dev.onyxcentersource.com',
  hostname: 'pioneer-ci2.dev.onyxcentersource.com',
  onyxCommonDataUrl: 'https://pioneer-ci2-service.dev.onyxcentersource.com/ocd/api',

  googleAnalytics: {
    id: 'UA-96125697-1',
    loadType: 'auto'
  }
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/environments/environment.ci2.ts